import { FC, useContext } from 'react';
import { BuildInAppToolId, IAppToolProps, IAppToolsContext } from '../../../types/appTools';
import CollaborationToolEnabled from '../../../toolsEnabled/CollaborationToolEnabled';
import CollaborationWrapper from '../../Wrapper/CollaborationWrapper/CollaborationWrapper';
import AppToolsContext from '../../../context/AppToolsContext';
import AppTool from './AppTool';

const CollaborationAppTool: FC<IAppToolProps> = ({ selectedApp }) => {
    const { eventUniqueName } = useContext<IAppToolsContext>(AppToolsContext);
    return (
        <CollaborationToolEnabled>
            {({ isLoading, isEnabled }) => (
                <AppTool
                    selectedApp={selectedApp}
                    appTool={BuildInAppToolId.SessionChats}
                    isEnabled={isEnabled}
                    isLoading={isLoading}
                    expandByDefault={true}
                >
                    <CollaborationWrapper eventUniqueName={eventUniqueName} />
                </AppTool>
            )}
        </CollaborationToolEnabled>
    );
};

export default CollaborationAppTool;
